import { useNavigator } from "@/contexts/navigator/NavigatorContext";
import { useEntities } from "@/contexts/entities/EntitiesContext";
import { CompetencyActivityCounter } from "./CompetencyActivityCounter";
import Image from "next/image";
import { Competency } from "@/lib/models";

type OutcomeAreaCompetencyListProps = {
  outcomeAreaId: string;
  learnerOutcomeId: string;
  changeCompetency: (competencyId: string) => Promise<void>;
};

export const OutcomeAreaCompetencyList = ({
  learnerOutcomeId,
  outcomeAreaId,
  changeCompetency,
}: OutcomeAreaCompetencyListProps) => {
  const { activeCompetencyId } = useNavigator();
  const { getOutcomeArea, getCompetency } = useEntities();

  const outcomeArea = getOutcomeArea(outcomeAreaId)!;
  const competencies = outcomeArea.competencies.map(
    getCompetency,
  ) as Competency[];

  return (
    <div className="pt-5">
      <h3
        className="mx-4 mb-4 inline-block font-roobert text-sm font-normal leading-tight text-neutral-600"
        id={`${outcomeArea.name.replaceAll(" ", "")}`}
      >
        {outcomeArea.name}
      </h3>
      <ol
        aria-labelledby={`${outcomeArea.name.replaceAll(" ", "")}`}
        role="tablist"
      >
        {competencies.map((competency) => {
          const isCompetencySelected = activeCompetencyId === competency.id;
          return (
            <li
              key={competency.name}
              className={`group mx-2 flex cursor-pointer items-center justify-between text-xl font-medium ${
                isCompetencySelected
                  ? `hover:none bg-${learnerOutcomeId}-30`
                  : `hover:bg-xq-grey`
              } rounded-lg active:bg-tab-bg-press`}
              onClick={() => changeCompetency(competency.id)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  changeCompetency(competency.id);
                }
              }}
              role="tab"
              aria-label={competency.name}
              aria-selected={isCompetencySelected}
              tabIndex={0}
              id={competency.id}
            >
              <div className="flex items-center justify-center">
                <div className="my-2 ml-2 mr-3 h-[48px] w-[42px] shrink-0">
                  {competency.icon.sourceUrl && (
                    <Image
                      src={competency.icon.sourceUrl}
                      alt=""
                      width={42}
                      height={48}
                    />
                  )}
                </div>
                <div className="font-roobert text-sm font-normal">
                  {competency.name}
                </div>
              </div>
              <CompetencyActivityCounter competencyId={competency.id} />
            </li>
          );
        })}
      </ol>
    </div>
  );
};
